import * as React from 'react';
import { Config } from '../../../helper';
import { columnValue, linkAttributes, safeHref } from './helper';

// One table cell. Render depends on the column's configured type: a sanitized link, a list,
// or plain text. Empty values render an explicit placeholder.
export default function Cell({result, column}) {
  const value = columnValue(result, column.field);

  if (value === '' || value === null || value === undefined) {
    return <td data-col={column.label}><span className='cell--empty'>{Config.I18n.Hits.EmptyCell}</span></td>;
  }

  if (column.type === Config.ColumnTypes.Url) {
    const href = safeHref(value);
    return (
      <td data-col={column.label}>
        {href ? <a href={href} {...linkAttributes(column.attributes)}>{value}</a> : value}
      </td>
    );
  }

  if (column.type === Config.ColumnTypes.List) {
    const items = Array.isArray(value) ? value : `${value}`.split('\n').filter(Boolean);
    return (
      <td data-col={column.label}>
        <ul className='cell--list'>
          {items.map((item, idx) => <li key={idx}>{item}</li>)}
        </ul>
      </td>
    );
  }

  if (column.type === Config.ColumnTypes.Links) {
    const items = Array.isArray(value) ? value : [value];
    return (
      <td data-col={column.label}>
        <ul className='cell--list'>
          {items.map((item, idx) => {
            const normalized = (item && typeof item === 'object')
              ? item
              : { url: item, text: item };
            const href = safeHref(normalized?.url);
            const text = normalized?.text || normalized?.url || Config.I18n.Hits.EmptyCell;
            return (
              <li key={idx}>
                {href ? <a href={href} {...linkAttributes(column.attributes)}>{text}</a> : text}
              </li>
            );
          })}
        </ul>
      </td>
    );
  }

  // Wrap the value in a div: `max-width` is ignored on a <td> (table layout sizes columns
  // by content), but works on the inner div, so the text cell caps + wraps via
  // `.data-type--string` while other columns stay single-line. Mirrors the grouped table.
  const type = column.type || Config.ColumnTypes.String;
  return (
    <td data-col={column.label}>
      <div data-type={type} className={`data-type--${type}`} data-column={column.field}>{value}</div>
    </td>
  );
}
